import {ChangeDetectorRef, Component, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {CrystalClearFrontUrl} from '../../shared/pages/crystal-clear-front-url';
import {ConfigService} from "../../services/config/config.service";
import {DomSanitizer} from "@angular/platform-browser";
import {CcBaseComponent} from "../cc-base.component";
import {MessageService} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";
import {AppConfigService} from "../../services/app-config.service";
import {ThemeService} from "../../services/tools/theme.service";

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LogoComponent extends CcBaseComponent {

  router: Router;
  readonly crystalClearFrontUrl = CrystalClearFrontUrl;
  customerName: String;
  customerLogo;
  customerLogoBackground: string = 'none';

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,
              router: Router,
              configService: ConfigService,
              protected appConfigService: AppConfigService,
              protected sanitizer: DomSanitizer,
              private themeService: ThemeService) {
    super(cdref, messageService, translateService);
    this.router = router;
    this.customerName = configService.customerName;
    this.loadLogo();
  }

  loadLogo(): void {
    if (this.appConfigService.imageCustomerLogoSmallImg) {
      this.customerLogo = this.sanitizer.bypassSecurityTrustUrl(
        this.appConfigService.imageCustomerLogoSmallImg
      );
      this.themeService.setProperty('customer-logo-bg', this.appConfigService.imageCustomerLogoBackground);
    }
  }

}
